import { Navigate } from "react-router-dom"
import { Login } from "../pages/login";
import { Register } from "../pages/register";
import { AnimationLayout } from "../layout/animation";
import { FirstAccess } from "../pages/firstAccess";
import { ForgetPassword } from "../pages/forgetPassword";
import { RedefinePassword } from "../pages/redefinePassword";
import { EmailSended } from "../pages/forgetPassword/email";

const PublicRouters = [
    {
        path: "/cliente",
        children: [
            {
                element: <Navigate to="/cliente/login" />,
                path: "/cliente",
            },
            {
                element: <Navigate to="/cliente" />,
                path: "/cliente/*",
            },
            {
                element: <Login />,
                path: "/cliente/login",
            },
        ]
    },
    {
        path: "/parceiro",
        children: [
            {
                element: <Navigate to="/parceiro/login" />,
                path: "/parceiro",
            },
            {
                element: <Navigate to="/parceiro" />,
                path: "/parceiro/*",
            },
            {
                element: <Login isClient={false}/>,
                path: "/parceiro/login",
            },
        ]
    },
    {
        element: <AnimationLayout />,
        children: [
            {
                element: <Register />,
                path: "/cadastro",
            },
            {
                element: <Register isClient={false}/>,
                path: "/parceiro/cadastro",
            },
        ]
    }
]

export default PublicRouters;